import { render, staticRenderFns } from "./project-add-electric.vue?vue&type=template&id=44751aaf&scoped=true&"
import script from "./project-add-electric.vue?vue&type=script&lang=js&"
export * from "./project-add-electric.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44751aaf",
  null
  
)

export default component.exports